import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { businessActions, authenticationSelectors } from 'Ducks';

const ServicesProvider = ({ children }) => {
	const dispatch = useDispatch();
	const businessId = useSelector((item) => item?.user?.selectedBusinessId);
	const id = useSelector(authenticationSelectors.selectBusinessId);
	const isAuthenticated = useSelector(
		authenticationSelectors.selectAuthenticated
	);

	useEffect(() => {
		const selectedBusinessId = businessId || id;
		if (selectedBusinessId && isAuthenticated) {
			dispatch(
				businessActions.getBusinessRequest({ businessId: selectedBusinessId })
			);
		}
	}, [businessId, id, isAuthenticated, dispatch]);

	return <>{children}</>;
};

export default ServicesProvider;
